import { lazy } from "react";

export const JobPageContent = lazy(() => import("./JobPageContent"));
